import { render, staticRenderFns } from "./AddProductsStep.vue?vue&type=template&id=82a62fcc&scoped=true&"
import script from "./AddProductsStep.vue?vue&type=script&lang=js&"
export * from "./AddProductsStep.vue?vue&type=script&lang=js&"
import style0 from "./AddProductsStep.vue?vue&type=style&index=0&id=82a62fcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a62fcc",
  null
  
)

export default component.exports